import { render, staticRenderFns } from "./proReviewModifiers.vue?vue&type=template&id=41ca015a&scoped=true&"
import script from "./proReviewModifiers.vue?vue&type=script&lang=js&"
export * from "./proReviewModifiers.vue?vue&type=script&lang=js&"
import style0 from "./proReviewModifiers.vue?vue&type=style&index=0&id=41ca015a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41ca015a",
  null
  
)

export default component.exports